import Context from './context';
import { useLocale } from './hooks';
import LocaleProvider from './provider';
import withLocale from './with-locale';
export { LocaleProvider, useLocale, withLocale, Context };
export default LocaleProvider;
